<template>
  <div class="text-center">
    <v-combobox
      v-model="model"
      :items="items"
      :label="label"
      :disabled="isDisabled"
      :rules="rules"
      @update:search-input="onInput"
      @focus="onFocus"
      @blur="onBlur"
      @change="onSelect"
      item-text="title"
    >
      <template v-slot:append>
        <v-fade-transition leave-absolute>
          <v-progress-circular
            v-if="loading"
            size="24"
            color="info"
            indeterminate
          ></v-progress-circular>
        </v-fade-transition>
      </template>
    </v-combobox>
    <p
      v-if="isHint"
      class="text-left hint"
    >
      {{ $t('auto.addModel.hint') + ` "${input}"` }}
      <v-btn
        class="ml-5 justify-end"
        outlined
        color="warning"
        @click="addModel()"
      >
        {{ $t('common.button.add') }}
      </v-btn>
    </p>
    <p
      v-if="error"
      class="text-left error-message"
    >
      {{ error }}
    </p>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';

export default {
  name: 'ModelSelect',
  data() {
    return {
      input: '',
      disabled: true,
      loading: false,
      isTimeout: false,
      items: [],
      error: false,
    };
  },
  props: {
    label: String,
    rules: Array,
  },
  computed: {
    ...mapGetters({
      brandId: 'auto/getAutoBrandId',
    }),
    model: {
      get() {
        return this.$store.getters['auto/getAutoModel'];
      },
      set(value) {
        this.$store.commit('auto/setAutoFormModel', value);
      },
    },
    isDisabled() {
      return this.disabled && (this.brandId === null || typeof this.brandId === 'undefined');
    },
    isHint() {
      if (this.items.length === 0 && this.input !== '' && this.input !== null) {
        return true;
      }
      if (this.items.length && this.input !== '' && !this.searchItem()) {
        return true;
      }
      return false;
    },
  },
  watch: {
    brandId(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.setModel({ id: null, title: null });
      }
      if (newVal === null || typeof newVal === 'undefined') {
        this.disabled = true;
      }
    },
  },
  methods: {
    ...mapActions({
      loadModels: 'auto/fetchModelsData',
      createModel: 'auto/createModel',
    }),
    ...mapMutations({
      setModel: 'auto/setAutoFormModel',
    }),
    setLoading(state) {
      this.loading = state;
      this.disabled = state;
      return state;
    },
    onBlur(item) {
      if (this.items.length === 1 && item.srcElement.value === this.items[0].title) {
        this.setModel(this.items[0]);
      } else if ((this.model.id === null || typeof this.model.id === 'undefined') && item.srcElement.value !== '') {
        this.hint = true;
      }
    },
    async onFocus(item) {
      if (this.brandId) {
        this.loading = true;
        // load default items
        try {
          const data = {
            brandId: this.brandId,
            search: item.target.value,
          };
          const models = await this.loadModels(data);
          this.items = models;
          this.error = false;
        } catch (error) {
          this.error = error.message;
        }
        this.loading = false;
      }
    },
    async onInput(input) {
      if (this.brandId) {
        if (input === null) {
          this.hint = false;
          return true;
        }
        if (input === '') {
          this.hint = false;
        }
        this.input = input;
        const that = this;
        if (!this.isTimeout) {
          this.isTimeout = true;
          // wait 1 second and loading data
          setTimeout(async () => {
            const title = that.input;
            that.isTimeout = false;
            const models = await that.loadData(title);
            that.items = models;
            that.error = false;
            that.loading = false;
          }, 500);
        }
      }
      this.loading = false;
      return true;
    },
    async loadData(searchString) {
      if (!this.brandId) {
        return true;
      }
      this.loading = true;
      let models = [];
      try {
        const data = {
          brandId: this.brandId,
          search: searchString,
        };
        models = await this.loadModels(data);
      } catch (error) {
        this.error = error.message;
      }
      this.loading = false;
      return models;
    },
    onSelect() {
      if (this.model.id) {
        this.hint = false;
      }
    },
    async addModel() {
      this.error = false;
      // add new car brand
      try {
        const modelData = {
          brandId: this.brandId,
          title: this.input,
        };
        const modelId = await this.createModel(modelData);
        if (modelId) {
          this.setModel({ id: modelId, title: modelData.title });
          this.hint = false;
          this.error = false;
        } else {
          this.error = this.$t('common.errors.APIerror');
        }
      } catch (error) {
        this.error = error.message;
      }
      this.setLoading(false);
    },
    searchItem() {
      let find = false;
      this.items.forEach((element) => {
        if (this.input === element.title) {
          find = true;
        }
      });

      return find;
    },
  },
};
</script>

<style lang="scss" scoped>
.hint {
  color: #ff8a1f;
}
.error-message {
  color: red;
}
</style>
